import superagent from 'superagent';
import * as Alert from './Alert';
import i18n from "i18next";

const env = process.env.REACT_APP_ENV;
let API_URL = '/api/v1';

if (env === 'local') {
  API_URL = 'http://localhost:3006/api/v1';
}

const methods = ['get', 'post', 'put', 'patch', 'del'];

function formatUrl(path) {
  const adjustedPath = path[0] !== '/' ? `/${path}` : path;

  return API_URL + adjustedPath;
}

export default class ApiClient {
  get token() {
    return this.constructor.token;
  }

  set token(token) {
    this.constructor.token = token;
  }

  get loading() {
    return this.constructor.loading;
  }

  set loading(bool) {
    this.constructor.loading = bool;
  }

  constructor() {
    methods.forEach((method) => {
      this[method] = (path, { params, data } = {}) => new Promise(
        (resolve, reject) => {
          const request = superagent[method](formatUrl(path));

          request.timeout(300000);

          if (params) {
            request.query(params);
          }

          if (path && path.indexOf('download') > 1) {
            request.responseType('blob');
          }

          if (data) {
            data.accessToken = this.token;
            data.oauthAccessToken = localStorage.getItem('oauth2Token');
            request.send(data);
          }

          if (this.loading) Alert.loading();

          request.end(async (err, { body } = {}) => {
            if (err) {
              Alert.error(i18n.t("errorAlertTitle"), (body ? i18n.t(body.message) : err));
              localStorage.setItem('tokenExpired', body && body.data && body.data.isExpired);

              return reject(body || err);
            }

            if (body && body.message) {
              Alert.success(i18n.t("successAlertTitle"), i18n.t(body.message));
            } else {
              Alert.close();
            }

            return resolve(body);
          });
          this.loading = false;
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/helpers/ApiClient.js